import Price from 'components/Price'
import React from 'react'
import { AiOutlineHeart } from 'react-icons/ai'

import * as S from './styles'

type Props = {
  image: string
  price: string
  title: string
  publisher: string
}

const Card = ({ image, price, title, publisher }: Props) => {
  return (
    <S.Wrapper>
      <img src={image} alt="Game" />

      <S.WrapperTitle>
        <p className="title">{title}</p>
        <AiOutlineHeart size={24} color="#F231A5" />
      </S.WrapperTitle>

      <p className="publisher">{publisher}</p>
      <Price price={price} />
    </S.Wrapper>
  )
}

export default Card
